export enum BidComparisonColumnStatus {
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  DONE = 20,
  FAILED = -20,
}
